
    import { mapState, mapActions, mapMutations } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faEyeSlash as farEyeSlash,
    } from '@fortawesome/pro-regular-svg-icons/faEyeSlash';

    import {
        faEye as farEye,
    } from '@fortawesome/pro-regular-svg-icons/faEye';

    import { Bus } from '@/utils/bus';

    export default {
        name: 'JobHide',

        components: {
            FontAwesomeIcon,
        },

        props: {
            jobUuid: {
                type: String,
                required: true,
            },

            isDark: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                icons: {
                    farEyeSlash,
                    farEye,
                },
                showPromptModal: false,
                loginPrompt: {
                    component_name: 'LoginPrompt',
                    title: 'Hide job',
                    code: 'SIMPLE_LOGIN',
                    page_referral_element: 'job_hide',
                    site_position: 'login_signup_popup',
                    options: {
                        login_redirect: '_none',
                    },
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_meJobEvents: state => state.me.jobEvents,
            }),

            isHiddenJob() {
                const job = this.$_meJobEvents.find(o => o.job_uuid === this.jobUuid);
                return job && job.is_hidden;
            },
        },

        methods: {
            ...mapActions('me', {
                $_toggleJobVisibility: 'toggleJobVisibility',
            }),

            ...mapMutations('me', {
                $_PUT_JOB_EVENT: 'PUT_JOB_EVENT',
            }),

            openPromptModal() {
                this.showPromptModal = true;
            },

            closePromptModal() {
                this.showPromptModal = false;
            },

            onPromptSuccess() {
                this.toggleJobVisibility();
                this.closePromptModal();
            },

            toggleJobVisibility() {
                this.$_toggleJobVisibility(this.jobUuid).then(() => {
                    Bus.$emit('onToggleJobVisibility', { jobUuid: this.jobUuid });
                    this.$_PUT_JOB_EVENT({ job: this.jobUuid, status: 'is_hidden' });
                });
            },

            onClick() {
                if (this.$_me.id) {
                    this.toggleJobVisibility();
                } else {
                    this.openPromptModal();
                }
            },
        },
    };
